theme.loadMoreSetup = () => {
  const loadMoreButton = document.querySelector(".load-more");
  if (!loadMoreButton) return;

  const state = initializeState(loadMoreButton);
  const observer = createIntersectionObserver(state);
  observer.observe(loadMoreButton);

  document.addEventListener('click', handleLoadMoreClick(state));

};

function initializeState(loadMoreButton) {
  return {
    currentGrid: document.querySelector("#main-collection-product-grid"),
    newProducts: false,
    newPagination: false,
    newPageLoading: false,
    nextPageClicked: false,
    nextUrl: loadMoreButton.getAttribute("data-next-url"),
    currentPage: parseFloat(loadMoreButton.getAttribute('data-current-page'))
  };
}

function createIntersectionObserver(state) {
  
  return new IntersectionObserver((entries) => {
    if (entries[0].intersectionRatio <= 0 || state.newPageLoading) return;
    state.newPageLoading = true;
    fetchNextPage(state);
  });
}

function fetchNextPage(state) {

  fetch(state.nextUrl)
    .then((response) => response.text())
    .then((html) => processNewPageContent(html, state))
    .catch((error) => console.log(error));

}

function processNewPageContent(html, state) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  state.newProducts = doc.querySelectorAll("#main-collection-product-grid li");
  const newPaginationEl = doc.querySelector(".load-more__wrapper");
  state.newPagination = newPaginationEl ? newPaginationEl.innerHTML : false;
  
  if (state.nextPageClicked || state.currentPage >= 3) {
    updatePageContent(state);
  }
 
}

function updatePageContent(state) {
  appendNewProducts(state);
  updatePagination(state);
  refreshPageComponents();
  
}

function appendNewProducts(state) {
  state.newProducts.forEach((item) => {
    state.currentGrid.appendChild(item);
  });
 
}

function updatePagination(state) {
  const loadMoreButton = document.querySelector(".load-more");
  if (state.newPagination && loadMoreButton) {
    loadMoreButton.parentNode.innerHTML = state.newPagination;
  }
 
}

function refreshPageComponents() {
  theme.scrollAnimations();
  theme.lazyImages();
  theme.totalColors();
  theme.loadMoreSetup();
  productGridClicks();
  
}

function handleLoadMoreClick(state) {
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  return function(event) {
    if (!event.target.matches(".load-more")) return;
    
    event.preventDefault();
    
    if (!state.newProducts) {
      state.nextPageClicked = true;
      return;
    }
    
    updatePageContent(state);
  };
  
}

const productGridClicks = () => {
  const allGridLinks = document.querySelectorAll('#main-collection-product-grid a');
  const mainGrid = document.querySelector('#main-collection-product-grid');
  allGridLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      
      let previousInfo = {
        "scrollY": window.scrollY,
        "href": window.location.href,
        "page_html": mainGrid.innerHTML
      }
      window.localStorage.setItem('previousInfo', JSON.stringify(previousInfo));
      sessionStorage.setItem('scrollPosition', window.scrollY);

    
      return false;
    })
  });
  
};

const checkState = () => {
  const previousInfo = JSON.parse(window.localStorage.getItem('previousInfo'));
  if (previousInfo) {
    if (previousInfo.href === window.location.href) {
      const loader = document.querySelector('.collection .loading-overlay');
      
      if(loader) {
        loader.style.display = 'block';
      }
      const mainGrid = document.querySelector('#main-collection-product-grid');
      mainGrid.innerHTML = previousInfo.page_html;
      
      
      // theme.totalColors();
      
      window.localStorage.removeItem('previousInfo');
      productGridClicks();
      window.scrollTo(0, previousInfo.scrollY);
      theme.scrollAnimations();
      theme.lazyImages();

      if(loader) {
        loader.style.display = 'none';
      }
    }
  }
  
}

function sizeTiles() {
  checkState();
  const marketingTiles = document.querySelectorAll(".marketing-tile");
  if (marketingTiles.length >= 1) {
    const basis = document.querySelector(
      ".card--product .card__inner .media"
    );
    const matchHeight = basis.offsetHeight;
    marketingTiles.forEach(function (tile, t) {
      if (tile.closest('.wide_marketing_tile.responsive') || (tile.closest('.wide_marketing_tile.responsive') && window.innerWidth < 1024)) {
        tile.querySelector(".card__inner").style.height = 'auto';
      } else {
        tile.querySelector(".card__inner").style.height = matchHeight + "px";
      }
    });
  }
  
}

window.addEventListener("resize", sizeTiles);
window.addEventListener("load", () => {
  sizeTiles();
  theme.loadMoreSetup();
  productGridClicks();
  
});
